<div class="select-container">
  <label>
    {{label}}
    <select [class.invalid]="control!.touched && control!.invalid" [formControl]="control!" (focus)="handleFocus()" (blur)="handleBlur()">
      <option *ngFor="let option of options" [value]="option">{{option}}</option>
    </select>
    <span *ngIf="control?.touched && !isFocused && control?.errors" class="validation-message">
      <ng-container *ngIf="control!.errors!['required']">Please select an option</ng-container>
    </span>
  </label>
</div>